import FixaTable, {
  FixaTableBody,
  FixaTableHeader,
} from "@coworker/apprestructured/src/shared/wrappers/FixaTable/FixaTable";
import { BasePermission } from "../../types/BasePermission";
type Props = {
  permissions: BasePermission[];
  isLoading: boolean;
};

const PermissionsPanel = ({ permissions, isLoading }: Props) => {
  return (
    <FixaTable fullWidth>
      <FixaTableHeader>
        <tr>
          <th>Code</th>
          <th>Description</th>
          <th>Created</th>
          <th>Updated</th>
        </tr>
      </FixaTableHeader>
      <FixaTableBody>
        {isLoading ? (
          <tr>
            <td colSpan={4}>Loading...</td>
          </tr>
        ) : permissions.length === 0 ? (
          <tr>
            <td colSpan={4}>No permissions found</td>
          </tr>
        ) : (
          permissions.map((permission: BasePermission) => (
            <tr key={permission.code}>
              <td>{permission.code}</td>
              <td>{permission.description}</td>
              <td>
                {permission.created_at
                  ? new Date(permission.created_at).toLocaleDateString()
                  : "-"}
              </td>
              <td>
                {permission.updated_at
                  ? new Date(permission.updated_at).toLocaleDateString()
                  : "-"}
              </td>
            </tr>
          ))
        )}
      </FixaTableBody>
    </FixaTable>
  );
};

export default PermissionsPanel;
